import { cva, type VariantProps } from 'class-variance-authority';

/**
 * ExpertQuote card variant styles using Class Variance Authority (CVA).
 * All styles use design tokens from the HEN Design System.
 *
 * Card: white background, 10px rounded corners (rounded-md), subtle border (neutral-200) and subtle shadow.
 */
export const expertQuoteVariants = cva([
  'bg-white',
  'rounded-md',
  'border',
  'border-neutral-200',
  'shadow-sm',
  'p-4',
  'text-left',
  'py-7',
  'px-8',
]);

export type ExpertQuoteVariantProps = VariantProps<typeof expertQuoteVariants>;
